import script from "./Place.vue?vue&type=script&setup=true&name=MerchantDetail&lang=js"
export * from "./Place.vue?vue&type=script&setup=true&name=MerchantDetail&lang=js"

import "./Place.vue?vue&type=style&index=0&id=eddf3db2&scoped=true&lang=css"

import exportComponent from "D:\\project\\web\\clue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eddf3db2"]])

export default __exports__